import React, { useState, useMemo } from "react";
import { Button, Dropdown, Spinner } from "flowbite-react";
import { Dark } from "../../../../../Theme/Theme";
import "./AddSymbol.css";
import moment from "moment";
import Backend from "../../../../../Backend/Backend";
import toast from "react-hot-toast";

const backend = await new Backend().init();

export default function Nse() {
  const [loading, setLoading] = useState(false);
  const [symbol, setSymbol] = useState("");
  const [date, setDate] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  // GENERATE VALUES — much cleaner
  const dates = useMemo(() => Array.from({ length: 31 }, (_, i) => i + 1), []);
  const months = useMemo(() => Array.from({ length: 5 }, (_, i) => moment().add(i, "months").format("MMM")), []);
  const years = useMemo(() => Array.from({ length: 5 }, (_, i) => moment().add(i, "years").format("YY")), []);
  const fullYears = useMemo(() => Array.from({ length: 5 }, (_, i) => moment().add(i, "years").format("YYYY")), []);

  const symbols = ["BANKNIFTY", "NIFTY", "FINNIFTY", "MIDCPNIFTY"];

  const submit = () => {
    if (!date) return toast.error("Select Date!");
    if (!month) return toast.error("Select Month!");
    if (!year) return toast.error("Select Year!");

    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol,
      date: date.toString().padStart(2, "0"),
      month,
      year,
    };

    backend.add_nse(data).then((r) => {
      setLoading(false);
      r.error == "False" ? toast.success(r.message) : toast.error(r.message);
    });
  };

  // REUSABLE DROPDOWN GENERATOR
  const renderDropdown = (label, value, setter, list, displayList = null) => (
    <div className="nseContainer border-2 border-[var(--hover)]">
      <div className="nseItem label">{label} :</div>
      <div className="nseItem label">
        <Dropdown
          value={value}
          className="dropDown"
          label={value || `SELECT ${label}`}
          dismissOnClick={true}
          style={{ backgroundColor: Dark.primary }}
        >
          <Dropdown.Item onClick={() => setter("")}>N/A</Dropdown.Item>
          {list.map((item, i) => (
            <Dropdown.Item key={i} onClick={() => setter(item)}>
              {displayList ? displayList[i] : item}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </div>
    </div>
  );

  return (
    <div className="flex flex-col items-center justify-center">
      {renderDropdown("SYMBOL", symbol, setSymbol, symbols)}

      {renderDropdown("DATE", date, setDate, dates)}

      {renderDropdown("MONTH", month, setMonth, months)}

      {renderDropdown("YEAR", year, setYear, years, fullYears)}

      <Button
        onClick={!loading ? submit : null}
        className="w-full max-w-sm mt-4 text-white font-semibold !bg-[var(--primary)] hover:brightness-90 focus:ring-0 transition-all flex items-center justify-center rounded-lg"
      >
        <div className="flex items-center gap-2">
          {loading && <Spinner size="sm" />}
          {!loading && "SUBMIT"}
        </div>
      </Button>
    </div>
  );
}
